import React, { Component } from 'react';
import helper from '../services/helper';

export default class MessageBar extends Component {
    render() {
        let that = this;
        let style = {
            base: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                fontSize: 13,
                width: '100%',
                height: 42,
                color: '#CCC',
                padding: '7px 8px',
                backgroundColor: '#414255',
                textAlign: 'left',
                transition: 'all 0.2s ease-in-out',
                fontWeight: 400,
                boxSizing: 'border-box',
                overflow: 'hidden',
                whiteSpace: 'no-wrap'
            },
            add: {
                float: 'right',
                display: 'inline-block',
                padding: '8px 12px',
                marginLeft: 6,
                marginBottom: 20,
                backgroundColor: '#38B08C',
                borderRadius: '4px',
                color: 'rgba(255,255,255,0.9)'
            },
            subtract: {
                float: 'right',
                display: 'inline-block',
                padding: '8px 12px',
                marginLeft: 6,
                marginBottom: 20,
                backgroundColor: '#AA3F1D', //2F304C
                borderRadius: '4px',
                color: 'rgba(255,255,255,0.9)'
            },
            addAmount: {
                color: 'rgba(255,255,255,0.6)',
                marginLeft: 6
            },
            subtractAmount: {
                color: 'rgba(255,255,255,0.6)',
                marginLeft: 6
            },
            overlay: {
                position: 'absolute',
                top: 0,
                right: '50%',
                bottom: 0,
                left: 0,
                background: 'linear-gradient(to right, rgba(65,66,85,1) 0%,' +
                ' rgba(65,66,85,0) 100%)',
                pointerEvents: 'none'
    }
        };

        return (
            <div style={style.base}>
                <div style={style.overlay}></div>
                    {this.props.transactions ?
                        Object.keys(this.props.transactions).map(function(id, i) {
                            return (<div key={id} style={style[that.props.transactions[id].calc]}>
                                    {that.props.transactions[id].title}
                                    <span style={style[that.props.transactions[id].calc + 'Amount']}>
                                        {helper.formatAmount(that.props.transactions[id].amount)}
                                        </span>
                            </div>);
                        }) : null
                    }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/MessageBar.js